<template>
  <aside :class="{'open': openNav, 'app-side': true}">
    <div class="side-nav">
      <ul>
        <template v-if="section == 'monitors'">
        <li :class="{'active': ($route.name === 'MonitorsDashboardCategory' && $route.params.category === 'consumer') || monitorCurrent.category === 'consumer'}">
          <router-link :to="{ name: 'MonitorsDashboardCategory', params: { category: 'consumer' }}" @click.native="closeSide()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999"><path d="M438.09,273.32h-39.596c4.036,11.05,6.241,22.975,6.241,35.404v149.65c0,5.182-0.902,10.156-2.543,14.782h65.461c24.453,0,44.346-19.894,44.346-44.346v-81.581C512,306.476,478.844,273.32,438.09,273.32z"/><path d="M107.265,308.725c0-12.43,2.205-24.354,6.241-35.404H73.91c-40.754,0-73.91,33.156-73.91,73.91v81.581c0,24.452,19.893,44.346,44.346,44.346h65.462c-1.641-4.628-2.543-9.601-2.543-14.783V308.725z"/><path d="M301.261,234.815h-90.522c-40.754,0-73.91,33.156-73.91,73.91v149.65c0,8.163,6.618,14.782,14.782,14.782h208.778c8.164,0,14.782-6.618,14.782-14.782v-149.65C375.171,267.971,342.015,234.815,301.261,234.815z"/><path d="M256,38.84c-49.012,0-88.886,39.874-88.886,88.887c0,33.245,18.349,62.28,45.447,77.524c12.853,7.23,27.671,11.362,43.439,11.362c15.768,0,30.586-4.132,43.439-11.362c27.099-15.244,45.447-44.28,45.447-77.524C344.886,78.715,305.012,38.84,256,38.84z"/><path d="M99.918,121.689c-36.655,0-66.475,29.82-66.475,66.475c0,36.655,29.82,66.475,66.475,66.475c9.298,0,18.152-1.926,26.195-5.388c13.906-5.987,25.372-16.585,32.467-29.86c4.98-9.317,7.813-19.946,7.813-31.227C166.393,151.51,136.573,121.689,99.918,121.689z"/><path d="M412.082,121.689c-36.655,0-66.475,29.82-66.475,66.475c0,11.282,2.833,21.911,7.813,31.227c7.095,13.276,18.561,23.874,32.467,29.86c8.043,3.462,16.897,5.388,26.195,5.388c36.655,0,66.475-29.82,66.475-66.475C478.557,151.509,448.737,121.689,412.082,121.689z"/></svg>
            <span>Consumer</span>
          </router-link>
        </li>
        <li :class="{'active': ($route.name === 'MonitorsDashboardCategory' && $route.params.category === 'market') || monitorCurrent.category === 'market'}">
          <router-link :to="{ name: 'MonitorsDashboardCategory', params: { category: 'market' }}" @click.native="closeSide()">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m8.25 21.25c-2.481 0-4.5-2.019-4.5-4.5 0-.48.071-.937.212-1.357.175-.524.742-.805 1.265-.631.524.175.807.742.631 1.265-.071.216-.108.459-.108.723 0 1.378 1.122 2.5 2.5 2.5 1.146 0 2.167-.807 2.426-1.917.125-.538.666-.874 1.201-.746.538.125.872.664.746 1.201-.476 2.038-2.274 3.462-4.373 3.462z"/><path d="m23.25 21.5c-.07 0-.14-.01-.208-.029l-22.5-6.5c-.321-.093-.542-.387-.542-.721v-4.5c0-.334.221-.628.542-.721l22.5-6.5c.227-.063.471-.021.659.121s.299.364.299.6v17.5c0 .236-.111.458-.299.6-.132.098-.29.15-.451.15z"/><path d="m23 22.25c-.552 0-1-.448-1-1v-18.5c0-.552.448-1 1-1s1 .448 1 1v18.5c0 .552-.448 1-1 1z"/><path d="m1 16.25c-.552 0-1-.448-1-1v-6.5c0-.552.448-1 1-1s1 .448 1 1v6.5c0 .552-.448 1-1 1z"/></svg>
            <span>Market</span>
          </router-link>
        </li>
        </template>
        <template v-else>
        <li :class="{'active': $route.name === 'Dashboard'}">
          <router-link to="/dashboard" @click.native="closeSide()">
            <svg viewBox="0 0 24 24"><path d="m7.323 10.5h-2.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/><path d="m19.323 10.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/><path d="m7.323 14.5h-2.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/><path d="m19.323 14.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/><path d="m7.323 18.5h-2.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/><path d="m19.323 18.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/><path d="m21.25 23h-18.5c-1.517 0-2.75-1.233-2.75-2.75v-16.5c0-1.517 1.233-2.75 2.75-2.75h18.5c1.517 0 2.75 1.233 2.75 2.75v16.5c0 1.517-1.233 2.75-2.75 2.75zm-18.5-20.5c-.689 0-1.25.561-1.25 1.25v16.5c0 .689.561 1.25 1.25 1.25h18.5c.689 0 1.25-.561 1.25-1.25v-16.5c0-.689-.561-1.25-1.25-1.25z"/><path d="m23.25 6h-22.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h22.5c.414 0 .75.336.75.75s-.336.75-.75.75z"/></svg>
            <span>Dashboard</span>
          </router-link>
        </li>
        <li :class="{'active': $route.name === 'Search'}">
          <router-link to="/search" @click.native="closeSide()">
            <svg viewBox="0 0 512 512"><path d="m80 105c-8.284 0-15 6.716-15 15v80c0 8.284 6.716 15 15 15s15-6.716 15-15v-80c0-8.284-6.716-15-15-15z"/><path d="m381.323 279h55.677c41.355 0 75-33.645 75-75v-88c0-41.355-33.645-75-75-75h-362c-41.355 0-75 33.645-75 75v88c0 41.355 33.645 75 75 75h87.677c30.818 71.926 121.428 94.492 182.326 46.998l26.909 26.323c-8.521 17.266-5.902 39.158 8.942 54.001l50.911 50.911c8.821 8.822 20.579 13.767 33.276 13.767 25.945-.027 46.959-21.021 46.959-47 0-12.554-4.89-24.357-13.767-33.234l-50.911-50.912c-14.653-14.653-36.649-17.576-54.246-8.797l-26.894-26.308c6.221-8.04 11.264-16.702 15.141-25.749zm-306.323-30c-24.813 0-45-20.187-45-45v-88c0-24.813 20.187-45 45-45h362c24.813 0 45 20.187 45 45v88c0 24.813-20.187 45-45 45h-47.267c10.314-72.045-45.404-136-117.733-136-72.274 0-128.053 63.911-117.733 136zm134.067 45.933c-34.781-34.782-34.785-91.079 0-125.865 34.779-34.78 91.08-34.786 125.865 0 34.781 34.782 34.785 91.079 0 125.865-34.778 34.78-91.08 34.786-125.865 0zm217.042 66.134 50.911 50.912c6.644 6.643 6.645 17.397 0 24.041-6.64 6.64-17.396 6.645-24.041 0l-50.912-50.912c-3.211-3.211-4.979-7.48-4.979-12.021 0-15.229 18.428-22.613 29.021-12.02z"/></svg>
            <span>Research</span>
          </router-link>
        </li>
        <li v-if="currentArticle" :class="{'active': $route.name === 'Label'}">
          <router-link to="/label" @click.native="closeSide()">
            <svg viewBox="0 0 496 496"><path d="M448,88c0-49.344-87.848-88-200-88S48,38.656,48,88c0.009,2.686,0.277,5.365,0.8,8H48v312c0,49.344,87.848,88,200,88s200-38.656,200-88V96h-0.8C447.723,93.365,447.991,90.686,448,88z M432,408c0,34.768-73.936,72-184,72S64,442.768,64,408v-44.92C94.24,394.488,164.352,416,248,416s153.76-21.512,184-52.92V408z M432,328c0,34.768-73.936,72-184,72S64,362.768,64,328v-44.92C94.24,314.488,164.352,336,248,336s153.76-21.512,184-52.92V328z M432,248c0,34.768-73.936,72-184,72S64,282.768,64,248v-44.92C94.24,234.488,164.352,256,248,256s153.76-21.512,184-52.92V248z M432,168c0,34.768-73.936,72-184,72S64,202.768,64,168v-44.92C94.24,154.488,164.352,176,248,176s153.76-21.512,184-52.92V168z M248,160c-110.064,0-184-37.232-184-72s73.936-72,184-72s184,37.232,184,72S358.064,160,248,160z"/></svg>
            <span>Datacall</span>
          </router-link>
        </li>
        </template>
        <li class="open-nav">
          <a href="#" @click.prevent="toggleSide()">
            <svg viewBox="0 0 512 512"><path d="M367.954,213.588L160.67,5.872c-7.804-7.819-20.467-7.831-28.284-0.029c-7.819,7.802-7.832,20.465-0.03,28.284l207.299,207.731c7.798,7.798,7.798,20.486-0.015,28.299L132.356,477.873c-7.802,7.819-7.789,20.482,0.03,28.284c3.903,3.896,9.016,5.843,14.127,5.843c5.125,0,10.25-1.958,14.157-5.873l207.269-207.701C391.333,275.032,391.333,236.967,367.954,213.588z"/></svg>
          </a>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AppSide",
  computed: {
    ...mapGetters(["isAuthenticated", "section", "currentArticle", "monitorCurrent"])
  },
  data() {
    return {
      openNav: false
    }
  },
  methods: {
    toggleSide: function() {
      this.openNav = !this.openNav;
    },
    closeSide: function() {
      this.openNav = false;
    }
  }
};
</script>

<style lang="scss">
.app-side {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 98;
  padding-top: rem(40px);
  width: rem(40px);
  height: 100%;
  background-color: $color-sunset;

  &.open {
    width: rem(160px);
  }

  &.open .side-nav ul li svg {
    margin-right: rem(16px);
  }

  &.open .side-nav ul li a span {
    display: block;
  }

  &.open .side-nav ul li.open-nav svg {
    transform: rotate(180deg);
  }
}

.side-nav {
  margin-top: rem(32px);

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      display: block;
      margin-bottom: rem(16px);

      a {
        padding: rem(10px);
        line-height: 0;
        display: flex;
        align-items: center;
        @include prefix(transition, background 0.3s ease, webkit o);

        span {
          display: none;
          font-size: rem(14px);
          color: #fff;
        }

        &:hover {
          text-decoration: none;
        }
      }

      svg {
        width: rem(20px);
        height: rem(20px);
        fill: #fff;
        @include prefix(transition, fill 0.3s ease, webkit o);
      }

      &.active {

        a {
          background-color: rgba(255,255,255,.75);
        }

        svg {
          fill: #fff;
        }
      }

      &:hover {

        a {
          background-color: rgba(255,255,255,.1);

          span {
            color: #fff;
            text-decoration: none;
          }
        }
      }

      &.active:hover {

        a {
          background-color: rgba(255,255,255,.75);
        }

        svg {
          fill: #fff;
        }
      }

      &.open-nav a {
        justify-content: flex-end;
      }
    }
  }
}
</style>